import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { mergeDeep } from "../utils/ObjectHelpers";
const translationsFiles = {};
const nxI18n = {
    init(lang, tList, fallbackLang = "en", keySeparatorParam = ".", interpolationOptions) {
        const namespaces = Object.keys(tList).reduce((r, language) => [...r, ...Object.keys(tList[language])], []);
        // merge with the components translations
        mergeDeep(tList, translationsFiles);
        i18n.use(initReactI18next).init({
            resources: tList,
            lng: lang,
            fallbackLng: fallbackLang,
            keySeparator: keySeparatorParam,
            fallbackNS: namespaces,
            interpolation: {
                format: interpolationOptions && interpolationOptions.format ? interpolationOptions.format : (value) => value,
                defaultVariables: interpolationOptions && interpolationOptions.defaultVariables,
                escapeValue: false, // react already safes from xss
            },
        });
    },
    changeLocale: (lang) => i18n.changeLanguage(lang),
    keyExists: (key) => i18n.exists(key),
    addResources: (lang, namespace, resources) => i18n.addResources(lang, namespace, resources),
};
export default nxI18n;
//# sourceMappingURL=i18n.js.map